export default {
      id: "ic_sort2-usage",
      viewBox: "0 0 12 10",
      url: "/" + "images/icons.3.109.2.svg#ic_sort2-usage",
      toString: function () {
        return this.url;
      }
    }